<template>
  <div v-if="contactId != null" class="chat__header">
    <vs-navbar class="p-4 flex navbar-custom" color="white" type="flat">
        <div class="relative flex mr-4">
            <feather-icon icon="ArrowLeftIcon" class="mr-4 cursor-pointer" v-if="isSidebarCollapsed" @click.stop="$emit('openContactsSidebar')"></feather-icon>
        </div>
        <h6>{{ contactName }}</h6>
        <vs-spacer></vs-spacer>
    </vs-navbar>
  </div>
</template>

<script>
export default {
  props: {
    contactId: {
      type: String,
      required: true
    },
    isPinnedProp: {
      type: Boolean,
      required: true
    },
    isSidebarCollapsed: {
      type: Boolean,
      required: true
    },
    contacts: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      isPinnedLocal: this.isPinnedProp
    };
  },
  watch: {
    isPinnedProp(val) {
      this.isPinnedLocal = val;
    }
  },
  computed: {
    contactIndex() {
      return this.contacts.findIndex(contact => contact.contactId == this.contactId);
    },
    contactName() {
      return this.contacts[this.contactIndex].name;
    },
    getStatusColor() {
      return isActiveUser => {
        const userStatus = this.getUserStatus(isActiveUser);

        if (userStatus == "online") {
          return "success";
        } else if (userStatus == "do not disturb") {
          return "danger";
        } else if (userStatus == "away") {
          return "warning";
        } else {
          return "grey";
        }
      };
    }
  },
  methods: {
    getUserStatus(isActiveUser) {
      return isActiveUser
        ? this.$store.state.AppActiveUser.status
        : this.contacts[this.contactIndex].status;
    },
    toggleIsPinned() {
      const chatData = this.$store.getters["chat/chatDataOfUser"](this.contactId);
      if (chatData) {
        const payload = { id: this.contactId, value: !this.isPinnedLocal };
        this.$store.dispatch("chat/toggleIsPinned", payload);
      } else {
        this.$emit("toggleIsChatPinned", !this.isPinnedLocal);
      }
      this.isPinnedLocal = !this.isPinnedLocal;
    }
  }
};
</script>
